import { render, staticRenderFns } from "./ChartVentas.vue?vue&type=template&id=478cae71"
import script from "./ChartVentas.vue?vue&type=script&lang=js"
export * from "./ChartVentas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports